import { z } from "zod/v4";
import { OcpiDateTime } from "../ocpi.utils";
import { AuthMethod, ChargingPeriod, SessionLocation } from "./sessions";
import { Tariff } from "./tariffs";

export const Cdr = z.object({
  id: z.string().max(36),
  start_date_time: OcpiDateTime,
  stop_date_time: OcpiDateTime,
  auth_id: z.string().max(36),
  auth_method: AuthMethod,
  location: SessionLocation,
  meter_id: z.string().max(255).nullish(),
  currency: z.string().length(3),
  tariffs: z.array(Tariff).nullish(),
  charging_periods: z.array(ChargingPeriod).nonempty(),
  total_cost: z.number().nonnegative(),
  total_energy: z.number().nonnegative(),
  total_time: z.number().nonnegative(),
  total_parking_time: z.number().nonnegative().nullish(),
  remark: z.string().max(255).nullish(),
  last_updated: OcpiDateTime,
});

export const Cdrs = z.array(Cdr);
